// HomeAbout.jsx
import React from "react";
import "./HomeAbout.css";
import { People, EmojiObjects, Coffee, Groups } from "@mui/icons-material";

const HomeAbout = () => {
  return (
    <section className="home-about">
      <div className="about-container">
        {/* Header */}
        <div className="about-header">
          <h2 className="about-title">About Our Network</h2>
          <p className="about-subtitle">
            A community of professionals dedicated to mutual growth and support
            in business, mindset, and knowledge sharing.
          </p>
        </div>

        {/* Content Section */}
        <div className="about-content">
          {/* Left Side - Image */}
          <div className="about-image">
            <div className="image-wrapper">
              <div
                className="image-background"
                style={{
                  backgroundImage: "url('./about.jpeg')",
                }}
              />
              <div className="image-overlay" />
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="about-details">
            <div className="details-intro">
              <h3>Building Business Relationships That Last</h3>
              <p>
                We are a humble group of professionals who love to network and
                help build each other in business, mindset, and knowledge. Our
                focus is on creating a friendly and inviting environment where
                meaningful connections can flourish.
              </p>
            </div>

            {/* Features Grid */}
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">
                  <People className="icon" />
                </div>
                <div className="feature-content">
                  <h4>Professional Networking</h4>
                  <p>
                    Connect with professionals from diverse industries in a warm,
                    welcoming setting.
                  </p>
                </div>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <EmojiObjects className="icon" />
                </div>
                <div className="feature-content">
                  <h4>Knowledge Sharing</h4>
                  <p>
                    Exchange insights, experiences, and expertise to help
                    everyone grow together.
                  </p>
                </div>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <Coffee className="icon" />
                </div>
                <div className="feature-content">
                  <h4>Casual Environment</h4>
                  <p>
                    Weekly meetings at Craft.19 Coffee Shop make networking
                    relaxed and enjoyable.
                  </p>
                </div>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <Groups className="icon" />
                </div>
                <div className="feature-content">
                  <h4>Close-Knit Community</h4>
                  <p>
                    We maintain a supportive group where members genuinely care
                    about each others success.
                  </p>
                </div>
              </div>
            </div>
          </div>
      
        </div>
  
      </div>
    </section>
  );
};

export default HomeAbout;